export const MODULOS_CONTROLE_DE_ESTACOES = {
  ESTACOES: 'controledeestacoesestacoes',
  INSTALACAO: 'controledeestacoesinstalacao',
  CONFIGURACAO: 'controledeestacoesconfiguracao'
}

export const ACOES_CONTROLE_DE_ESTACOES = {
  VER: 'get',
  EDITAR: 'post',
  EXCLUIR: 'delete'
}

export const ACOES_DISPONIVEIS_POR_MODULO_CONTROLE_DE_ESTACOES = {
  [MODULOS_CONTROLE_DE_ESTACOES.ESTACOES]: ['get', 'post', 'delete'],
  [MODULOS_CONTROLE_DE_ESTACOES.INSTALACAO]: ['get', 'post', 'delete'],
  [MODULOS_CONTROLE_DE_ESTACOES.CONFIGURACAO]: ['get', 'post']
}

export function possuiPermissaoControleDeEstacoes (roles, module, action) {
  return (roles || []).some(role => role.module === module && role.action === action)
}

export function possuiAlgumaLeituraControleDeEstacoes (roles) {
  return Object.values(MODULOS_CONTROLE_DE_ESTACOES).some(module => (
    possuiPermissaoControleDeEstacoes(roles, module, ACOES_CONTROLE_DE_ESTACOES.VER)
  ))
}

export function obterAcessoControleDeEstacoes (roles) {
  return {
    estacoes: possuiPermissaoControleDeEstacoes(roles, MODULOS_CONTROLE_DE_ESTACOES.ESTACOES, ACOES_CONTROLE_DE_ESTACOES.VER),
    liberarEstacao: possuiPermissaoControleDeEstacoes(roles, MODULOS_CONTROLE_DE_ESTACOES.ESTACOES, ACOES_CONTROLE_DE_ESTACOES.EDITAR),
    esquecerEstacao: possuiPermissaoControleDeEstacoes(roles, MODULOS_CONTROLE_DE_ESTACOES.ESTACOES, ACOES_CONTROLE_DE_ESTACOES.EXCLUIR),
    instalacao: possuiPermissaoControleDeEstacoes(roles, MODULOS_CONTROLE_DE_ESTACOES.INSTALACAO, ACOES_CONTROLE_DE_ESTACOES.VER),
    criarCodigoInstalacao: possuiPermissaoControleDeEstacoes(roles, MODULOS_CONTROLE_DE_ESTACOES.INSTALACAO, ACOES_CONTROLE_DE_ESTACOES.EDITAR),
    revogarCodigoInstalacao: possuiPermissaoControleDeEstacoes(roles, MODULOS_CONTROLE_DE_ESTACOES.INSTALACAO, ACOES_CONTROLE_DE_ESTACOES.EXCLUIR),
    configuracao: possuiPermissaoControleDeEstacoes(roles, MODULOS_CONTROLE_DE_ESTACOES.CONFIGURACAO, ACOES_CONTROLE_DE_ESTACOES.VER),
    salvarConfiguracao: possuiPermissaoControleDeEstacoes(roles, MODULOS_CONTROLE_DE_ESTACOES.CONFIGURACAO, ACOES_CONTROLE_DE_ESTACOES.EDITAR)
  }
}

export function mensagemErroControleDeEstacoes (error, mensagemPadrao) {
  const mensagem = error?.response?.status === 403
    ? 'Você não tem permissão para realizar essa operação.'
    : mensagemPadrao
  const codigo = error?.response?.data?.codigo

  return codigo ? `${mensagem}\n\n${codigo}` : mensagem
}

export function mensagemErroDaAcaoControleDeEstacoes (error, mensagemPadrao) {
  const mensagem = error?.response?.data?.detail || mensagemPadrao

  return mensagemErroControleDeEstacoes(error, mensagem)
}
